<template>
	<div class="batch-header">
		<div class="header-section">
			<p class="row-data">
				<span>Batch Id</span>
				<span class="dots"></span>
				<span>{{ batch?.idFormatted }}</span>
			</p>
			<p class="row-data">
				<span>Created</span>
				<span class="dots"></span>
				<span>{{ batch?.createdAtFormatted }}</span>
			</p>
			<p class="row-data">
				<span>Prefund</span>
				<span class="dots"></span>
				<span>{{ batch?.createdAtFormatted }}</span>
			</p>
		</div>
		<div class="header-section">
			<p class="row-data">
				<span>Total</span>
				<span class="dots"></span>
				<span>{{ batch?.totalAmountFormatted }}</span>
			</p>
			<p class="row-data">
				<span>Disbursement Count</span>
				<span class="dots"></span>
				<span>{{ batch?.activePayoffCount }}</span>
			</p>
			<p class="row-data">
				<span>Disbursement Report Date</span>
				<span class="dots"></span>
				<span>{{ batch?.disbursementReportDateFormatted }}</span>
			</p>
		</div>
		<div class="header-section">
			<p class="row-data">
				<span>Approved By</span>
				<span class="dots"></span>
				<span>{{ batch?.approvedBy ?? 'N/A' }}</span>
			</p>
			<p class="row-data">
				<span>Approved Date</span>
				<span class="dots"></span>
				<span>{{ batch?.approvedAtFormatted ?? 'N/A' }}</span>
			</p>
			<p class="row-data">
				<span>Account Reports Date</span>
				<span class="dots"></span>
				<span>{{ batch?.accountReportsDateFormatted }}</span>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { toRefs } from 'vue';
	import { BatchDetailsModel } from '../../models/payoffBatches';

	const props = defineProps<{ batch: BatchDetailsModel | null }>();

	const { batch } = toRefs(props);
</script>

<style scoped>
	.batch-header {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 30px;
		width: 100%;
	}

	.header-section {
		display: flex;
		flex-direction: column;
	}

	.header-section p {
		margin: 0;
		padding: 5px 0;
	}

	.header-section p:last-child {
		margin-top: auto;
	}

	.row-data {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
	}

	.row-data span:first-child {
		font-weight: 800;
	}

	.row-data span:last-child {
		text-align: right;
	}

	.row-data span.dots {
		flex-grow: 1;
		border-bottom: 1px dotted #aaa;
		margin: 0 5px;
	}
</style>
